import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  import { EstateInterface } from "@/types/EstateInterface";
  import { getEoiLogoUrl } from "@/helpers/eoi/getEoiLogoUrl";
  import { getEstateMapRouteName } from "@/helpers/estateMapRoute";
  import router from "@/router";

  interface Props {
    estate?: EstateInterface;
    hideAuthButtons?: boolean;
    overAll?: boolean;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderCustomer',
  props: {
    estate: {},
    hideAuthButtons: { type: Boolean },
    overAll: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const businessId = computed(() => {
    return (router.currentRoute.value.query?.businessId as string) ?? null;
  });

  const logoUrl = computed(() => {
    if (!props.estate) return "";

    return getEoiLogoUrl(props.estate, businessId.value);
  });

  const estateMapRoute = computed(() => ({
    name: getEstateMapRouteName(props.estate?.type),
    params: { estateId: props.estate?._id },
    query: router.currentRoute.value.query,
  }));

const __returned__ = { props, businessId, logoUrl, estateMapRoute, computed, get EstateInterface() { return EstateInterface }, get getEoiLogoUrl() { return getEoiLogoUrl }, get getEstateMapRouteName() { return getEstateMapRouteName }, get router() { return router } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})